import React, { Component } from 'react';

class Header extends Component {

  /*stateの初期化*/
  state = { keyword: ''}

  /*valueを取得するためのイベントハンドラー。
  引数にeventを指定することでonChangeで呼び出された要素を参照できる*/
  onInputChangeHandler = (event) => {
    this.setState({keyword: event.target.value});
    this.props.onKeywordChanged(event.target.value);
  }

  render() {
    /*一度変数に代入*/
    const fontStyle = {
      fontFamily: "Titan One"
    }
    return (
      <nav className="navbar navbar-expand navbar-light bg-light mb-3 p-3">
        <h2 className="mb-0">
          <span className="bg-dark text-white p-2 mr-2">P</span>
          {/*定義した変数を挿入*/}
          <span className="d-none d-md-inline" style={fontStyle}>PenTube</span>
        </h2>
        <form className="form-group d-md-inline">
          {/*onChangeを指定することにより、inputタグの値が変更された時に、
          イベントハンドラが呼び出される*/}
          {/*stateがinputに何を表示させるかを伝えるために、inputタグのvalueにstateを渡す*/}
          <input onChange = {this.onInputChangeHandler}             value={this.state.keyword} className="form-control form-control-lg mr-sm-2" type="text" placeholder="検索..." aria-label="検索..."  />
        </form>
      </nav>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js